import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    selectedItem: JSON.parse(localStorage.getItem("selectedItem")) || null,
    defaultItem: "",
};

const selectedItemSlice = createSlice({
    name: "selectedItem",
    initialState,
    reducers: {
        setSelectedItem(state, action) {
            state.selectedItem = action.payload;
            localStorage.setItem("selectedItem", JSON.stringify(action.payload));
        },
        setDefaultItem(state, action) {
            state.defaultItem = action.payload;
        },
    },
});

export const { setSelectedItem, setDefaultItem } = selectedItemSlice.actions;
export default selectedItemSlice.reducer;
